// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"5b6a3e46","198":"e2e6eed8","454":"ad6d42e4","759":"9af1d6b3"}[chunkId] + ".chunk.js";
};